import Preloader from '../../common/Preloader/Preloader';
import classes from './ProfileInfo.module.css';
import userPhoto from '../../../assets/userPhoto.jpg'
import ProfileStatusWithHooks from './ProfileStatus';
import { useState } from 'react';
import ProfileDataForm from './ProfileDataForm';

const ProfileInfo = ({ profile, status, updateStatus, isOwner, savePhoto, saveProfile, ...props }) => {
  let [editMode, setEditMode] = useState(false)

  if (!profile) {
    return <Preloader />
  }

  const onMainPhotoSelected = (e) => {
    if (e.target.files.length) {
      savePhoto(e.target.files[0])
    }
  }

  return (
    <div>
      <div>
        <img className={classes.content_img} src="https://kartinkin.net/uploads/posts/2021-07/1627135437_5-kartinkin-com-p-anime-piksel-fon-anime-krasivo-7.png"
          alt="profile-header" />
      </div>
      <div className={classes.descriptionBlock}>
        <img className={classes.userPhoto} src={profile.photos.small != null ? profile.photos.large : userPhoto} alt="profile-avatar" />
        {isOwner && <input type="file" onChange={onMainPhotoSelected} />}
        {editMode
          ? <ProfileDataForm profile={profile} saveProfile={saveProfile} setEditMode={setEditMode} />
          : <ProfileData goToEditMode={() => { setEditMode(true) }} profile={profile} isOwner={isOwner} />}
        <ProfileStatusWithHooks status={status} updateStatus={updateStatus} />
      </div>
    </div>
  );
}

const ProfileData = ({ profile, isOwner, goToEditMode }) => {
  return <div>
    {isOwner && <div><button onClick={goToEditMode}>Edit</button></div>}
    <div>
      <b>FullName</b>: {profile.fullName}
    </div>
    <div><b>Looking for a job</b>: {profile.lookingForAJob ? "yes" : "no"}</div>
    {profile.lookingForAJob &&
      <div>
        <b>My professional skills</b>: {profile.lookingForAJobDescription}
      </div>
    }
    <div>
      <b>About me</b>: {profile.aboutMe}
    </div>
    <div>
      <b>Contacts</b>: {Object.keys(profile.contacts).map(key => {
        return <Contacts key={key} contactTitle={key} contactValue={profile.contacts[key]} />
      })}
    </div>
  </div>
}

// const ProfileDataForm = ({ profile }) => {
//   return <div>
//     <div>
//       <b>FullName</b>: {profile.fullName}
//     </div>
//     <div><b>Looking for a job</b>: {profile.lookingForAJob ? "yes" : "no"}</div>
//     {profile.lookingForAJob &&
//       <div>
//         <b>My professional skills</b>: {profile.lookingForAJobDescription}
//       </div>
//     }
//     <div>
//       <b>Contacts</b>: {Object.keys(profile.contacts).map(key => {
//         return <Contacts key={key} contactTitle={key} contactValue={profile.contacts[key]} />
//       })}
//     </div>
//   </div>
// }

const Contacts = ({ contactTitle, contactValue }) => {
  return <div className={classes.contacts}><b>{contactTitle}</b>: {contactValue}</div>
}

export default ProfileInfo;